import inspectionHistory from "Modules/evirPx/tabs/inspectionHistory/lan/en";
import defectsGtc from "Modules/evirPx/tabs/defectsGtc/lan/en";

let locales = {
  evirPx_inspection_history: "Inspection History",
  evirPx_defects: "Defects",
  evirPx_missing_inspections: "Missing Inspections",
  evirPx_inspection_builder: "Inspection Builder",
  evirPx_settings: "Settings",
  evirPx_record: "record",
  evirPx_records: "records",
};

locales = {
  ...locales,
  ...inspectionHistory,
  ...defectsGtc,
};

export default locales;
